import React, { Suspense } from 'react';
import { Route } from 'react-router';
import { bedLayoutSettings, bedTypeSettings } from '../constants/constants';
import GenericSettingContainer from '../containers/GenericSettingContainer/GenericSettingContainer';
import PageLoader from '../components/PageLoader/PageLoader';

const BedTypeSettingsPage = React.lazy(() => import('../pages/BedManagementSettingsPages/BedTypeSettingsPage'));
const BedLayoutSettingsPage = React.lazy(() => import('../pages/BedManagementSettingsPages/BedLayoutSettingsPage'));


const BedManagementSettingsRoutes = props => (
    <GenericSettingContainer {...props}>
        <Suspense fallback={<PageLoader />}>
            <Route path={bedTypeSettings} exact component={BedTypeSettingsPage} />
            <Route path={bedLayoutSettings} exact component={BedLayoutSettingsPage} />
        </Suspense>
    </GenericSettingContainer>
);

export default BedManagementSettingsRoutes;
